import { Layout } from 'antd';
import styles from './HowWork.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';
import { ArrowUpRightIcon, ChartIcon, ClipboardIcon, PhoneIcon, UserIcon } from '@/shared/constants/icon';

const { Content } = Layout;

const howWorkData = [
  {
    id: 1,
    title: 'title1',
    desc: 'desc1',
    icon: <PhoneIcon color="var(--color-cream)" />
  },
  {
    id: 2,
    title: 'title2',
    desc: 'desc2',
    icon: <ChartIcon color="var(--color-cream)" />
  },
  {
    id: 3,
    title: 'title3',
    desc: 'desc3',
    icon: <ClipboardIcon color="var(--color-cream)" />
  },
];

const examplesData = [
  {
    id: 1,
    q: 'q1',
    a: 'a1',
    data1: 'data1_1',
    data1Title: 'data1_1Title',
    data2: 'data1_2',
    data2Title: 'data1_2Title',
    data3: 'data1_3',
    data3Title: 'data1_3Title',
    data4: 'data1_4',
    data4Title: 'data1_4Title',
  },
  {
    id: 2,
    q: 'q2',
    a: 'a2',
    data1: 'data2_1',
    data1Title: 'data2_1Title',
    data2: 'data2_2',
    data2Title: 'data2_2Title',
    data3: 'data2_3',
    data3Title: 'data2_3Title',
    data4: 'data2_4',
    data4Title: 'data2_4Title',
  },
];

export const HowWork = () => {
  const t = useTranslations("aiAgent.howWork");
  const tEx = useTranslations("aiAgent.howWork.examples");

  return (
    <Content className={styles.root}>
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title')}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_cards}>
        {howWorkData.map((item) => (
          <section key={item.id} className={styles.root_cards_item}>
            <span className={styles.root_cards_item_count}>
              {String(item.id).padStart(2, '0')}
            </span>
            <div className={styles.root_cards_item_title}>
              <h3>{t(item.title)}</h3>
              <span className={styles.root_cards_item_title_icon}>{item.icon}</span>
            </div>
            <p className={styles.root_cards_item_desc}>{t(item.desc)}</p>
          </section>
        ))}
      </ScrollReveal>

      <section className={styles.root_examples_wrapper}>
        <ScrollReveal className={styles.root_examples_wrapper_title}>
          <h2>{tEx('title')}</h2>
          <h6>{tEx('desc')}</h6>
        </ScrollReveal>
        <ScrollReveal className={styles.root_examples}>
          {examplesData.map((item) => (
            <section key={item.id} className={styles.root_examples_item}>
              <div className={styles.qa_wrapper}>
                <div className={styles.qa}>
                  <span className={styles.icon}>AI</span>
                  <span className={styles.title}>«{tEx(item.q)}»</span>
                </div>
                <div className={styles.qa}>
                  <span className={styles.icon}><UserIcon color="var(--color-primary)" /></span>
                  <span className={styles.title}>«{tEx(item.a)}»</span>
                </div>
              </div>

              <span className={styles.arrow}><ArrowUpRightIcon size={'1.3vw'} /></span>

              <div className={styles.data_wrapper}>
                <h5>{tEx('dataTitle')}</h5>
                <div className={styles.data_grid}>
                  <div className={styles.data}>
                    <span className={styles.data_title}>{tEx(item.data1Title)}</span>
                    <span className={styles.data_text}>{tEx(item.data1)}</span>
                  </div>
                  <div className={styles.data}>
                    <span className={styles.data_title}>{tEx(item.data2Title)}</span>
                    <span className={styles.data_text}>{tEx(item.data2)}</span>
                  </div>
                  <div className={styles.data}>
                    <span className={styles.data_title}>{tEx(item.data3Title)}</span>
                    <span className={styles.data_text}>{tEx(item.data3)}</span>
                  </div>
                  <div className={styles.data}>
                    <span className={styles.data_title}>{tEx(item.data4Title)}</span>
                    <span className={styles.data_text}>{tEx(item.data4)}</span>
                  </div>
                </div>
              </div>
            </section>
          ))}
        </ScrollReveal>
      </section>
    </Content>
  );
};
